import React, {useState} from 'react';
import CancelIcon from '../../../imgs/cancelOffer.svg';
import {Select, Spin} from 'antd';
import {gql, useMutation} from '@apollo/client';
import {CANCEL_INTRO} from '../../../graphql/mutations/offers';
const {Option} = Select;

const CancelOfferModal = ({handleCancel, firstName, lastName, offerId}) => {
  const [reason, setReason] = useState('I no longer need the intro');
  const [loader, setLoader] = useState(false);

  const handleReason = (val) => {
    setReason(val);
  };

  const [cancelIntro] = useMutation(gql(CANCEL_INTRO));

    const handleCancelOffer = () => {
        if (reason) {
            setLoader(true)
            cancelIntro({
                variables: {
                    offerId: offerId,
                    reason: reason
                }
            }).then((res) => {
                setLoader(false);
                handleCancel()
            })
        }
    }

  return (
      <Spin className="loading" spinning={loader}>
    <div className="bounty-modal-wrapper submit-wrapper cancel-offer">
      <div className="center-content">
        <img src={CancelIcon} alt="CancelIcon" className="icon" />
        <h2 className="heading">Cancel offer from {firstName}</h2>
        <p>You’ll be charge a cancellation fee of $10.</p>
      </div>
      <div className="input-field">
        <label>Select reason for cancellation</label>
        <Select
          defaultValue="I no longer need the intro"
          value={reason}
          onChange={(val) => handleReason(val)}>
          <Option value="I no longer need the intro">
            I no longer need the intro
          </Option>
          <Option value="It’s taking too long">It’s taking too long</Option>
          <Option value="Other - Explain">Other - Explain</Option>
        </Select>
      </div>
      {reason === 'Other - Explain' && (
        <div className="input-field">
          <label>Other</label>
          <textarea
            placeholder="Please state reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}></textarea>
        </div>
      )}

      <div className="btn-row">
        <div className="col pl-0">
          <button className="btn-style" onClick={() => handleCancel()}>
            Cancel
          </button>
        </div>
        <div className="col p-0">
          <button className="btn-style" onClick={() => handleCancelOffer()}>Cancel for $10</button>
        </div>
      </div>
    </div>
    </Spin>
  );
};

export default CancelOfferModal;
